import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { SocietyProviderDataForm, SocietyProviderFilters } from '../../models/SocietyProvider';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';

const useSocietyProviderService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetSocietyProviders, setFetchingGetSocietyProviders] = useState(false);
    const [fetchingStoreSocietyProvider, setFetchingStoreSocietyProvider] = useState(false);
    const [fetchingEditSocietyProvider, setFetchingEditSocietyProvider] = useState(false);
    const [fetchingCreateSocietyProvider, setFetchingCreateSocietyProvider] = useState(false);
    const [fetchingUpdateSocietyProvider, setFetchingUpdateSocietyProvider] = useState(false);
    const [fetchingDeleteSocietyProvider, setFetchingDeleteSocietyProvider] = useState(false);
    const [fetchingActiveSocietyProvider, setFetchingActiveSocietyProvider] = useState(false);

    const getSocietyProviders = (filters: SocietyProviderFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        // Si hay society_id, usar el endpoint específico, sino usar el endpoint general
        let url: string;
        if (filters.society_id && filters.society_id > 0) {
            url = `${EndPoints.SOCIETY_PROVIDERS.GET_SOCIETY_PROVIDERS_BY_SOCIETY.replace(':society_id', filters.society_id.toString())}?${queryString}`;
        } else {
            url = `${EndPoints.SOCIETY_PROVIDERS.GET_SOCIETY_PROVIDERS}?${queryString}`;
        }

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetSocietyProviders
        });
    };

    const createSocietyProvider = (societyId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SOCIETY_PROVIDERS.CREATE_SOCIETY_PROVIDER.replace(':society_id', societyId.toString()),
            setFetching: setFetchingCreateSocietyProvider
        });
    };

    const storeSocietyProvider = (societyProvider: SocietyProviderDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.SOCIETY_PROVIDERS.STORE_SOCIETY_PROVIDER,
            body: societyProvider,
            setFetching: setFetchingStoreSocietyProvider
        });
    };

    const editSocietyProvider = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SOCIETY_PROVIDERS.EDIT_SOCIETY_PROVIDER.replace(':id', id.toString()),
            setFetching: setFetchingEditSocietyProvider
        });
    };

    const updateSocietyProvider = (id: number, societyProvider: SocietyProviderDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SOCIETY_PROVIDERS.UPDATE_SOCIETY_PROVIDER.replace(':id', id.toString()),
            body: societyProvider,
            setFetching: setFetchingUpdateSocietyProvider
        });
    };

    const deleteSocietyProvider = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.SOCIETY_PROVIDERS.DELETE_SOCIETY_PROVIDER.replace(':id', id.toString()),
            setFetching: setFetchingDeleteSocietyProvider
        });
    };

    const activeSocietyProvider = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            body: { active: active },
            url: EndPoints.SOCIETY_PROVIDERS.ACTIVE_SOCIETY_PROVIDER.replace(':id', id.toString()),
            setFetching: setFetchingActiveSocietyProvider
        });
    };

    return {
        fetchingGetSocietyProviders,
        fetchingStoreSocietyProvider,
        fetchingEditSocietyProvider,
        fetchingCreateSocietyProvider,
        fetchingUpdateSocietyProvider,
        fetchingDeleteSocietyProvider,
        fetchingActiveSocietyProvider,
        getSocietyProviders,
        createSocietyProvider,
        storeSocietyProvider,
        editSocietyProvider,
        updateSocietyProvider,
        deleteSocietyProvider,
        activeSocietyProvider
    };
};

export default useSocietyProviderService;
